export interface AgentOption {
    id: number;
    name: string;
    isActive?: number;
}

/**
 * 判断点击"Agent智能执行"时是否应拦截：仅当管理员显式指定了智能体，且该智能体已被禁用（isActive=0）。
 * 非管理员使用默认交易智能体时，其禁用状态由后端在 AgentExecutionWrapper 统一拦截兜底，前端无法在此判定。
 *
 * @param selectedAgentId 当前选中的智能体ID（管理员可指定，可能为 undefined/null）
 * @param agents 已加载的智能体列表（含 isActive）
 * @returns true 表示应拦截（智能体已禁用）
 */
export function isAgentDisabledForTrigger(
    selectedAgentId: number | null | undefined,
    agents: AgentOption[]
): boolean {
    if (selectedAgentId == null) {
        return false;
    }
    const target = agents.find(a => a.id === selectedAgentId);
    return !!target && target.isActive === 0;
}
